module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('img', {
    staticClass: "banner",
    attrs: {
      "src": "http://shared.youdao.com/dict/market/oxford-activity/imgs/masterBanner.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('get-code', {
    staticClass: "main",
    attrs: {
      "isCanGet": _vm.isCanGet,
      "signId": _vm.signId
    }
  }), _vm._v(" "), _c('geted-number', {
    attrs: {
      "list": _vm.data
    }
  }), _vm._v(" "), _c('rule', {
    staticClass: "rule"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce16b37e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 143
// module chunks = 1